import type { HTMLAttributes, ReactNode } from 'react';

export interface TypeChipProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

/**
 * Document-type chip — 18px height, mono, --surface-2 fill, no border.
 * Matches dashboard.html `.tchip`.
 */
export function TypeChip({ children, className, ...rest }: TypeChipProps) {
  const cls = ['pn-tchip', className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
